import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 place-items-center sm:p-4 h-screen" }
const _hoisted_2 = { class: "flex flex-col h-full sm:w-3/4 w-full gap-4" }
const _hoisted_3 = { class: "flex flex-col items-start" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold" }, "Mensaje", -1)
const _hoisted_5 = { class: "flex flex-col gap-4 shadow-xl rounded-md p-4 h-full sm:p-8" }
const _hoisted_6 = { class: "flex flex-row justify-between gap-2" }
const _hoisted_7 = { class: "flex flex-col gap-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", { class: "text-md font-semibold" }, "Asunto", -1)
const _hoisted_9 = { class: "text-xl font-bold" }
const _hoisted_10 = {
  key: 0,
  class: "text-sm text-gray-600"
}
const _hoisted_11 = { class: "flex flex-col gap-4" }
const _hoisted_12 = { class: "flex flex-row items-center justify-between gap-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", { class: "text-md font-semibold" }, "Destinatarios", -1)
const _hoisted_14 = {
  key: 0,
  class: "text-sm text-gray-600"
}
const _hoisted_15 = { class: "flex flex-row flex-wrap gap-4 max-h-64 overflow-scroll" }
const _hoisted_16 = { class: "flex flex-col bg-gray-100 rounded-full px-4 py-1.5" }
const _hoisted_17 = { class: "text-sm font-semibold text-gray-800" }
const _hoisted_18 = { class: "text-xs" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_20 = { class: "relative flex flex-col gap-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold" }, "Mensaje", -1)
const _hoisted_22 = { class: "flex flex-col border-gray-300 rounded-md min-h-64" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_24 = { class: "flex flex-col gap-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold" }, "Archivos adjuntos", -1)
const _hoisted_26 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 1,
  class: "flex flex-row justify-center items-center w-full text-gray-400 p-8"
}
const _hoisted_29 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, "Este mensaje no cuenta con archivos adjuntos", -1)

import { ref, computed, watch, onMounted } from "vue";

import { useRoute, useRouter } from "vue-router";

import { storeToRefs } from "pinia";
import { parseUrl, extractFilename } from "@/services/utils";

import useNotificationStore from "@/stores/notification";


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageViewWithId',
  setup(__props) {

const notificationStore = useNotificationStore();
const route = useRoute();
const router = useRouter();

const { getMessageResponse, message } = storeToRefs(notificationStore);

const goBack = () => {
  router.push({ name: "message-list" });
};

onMounted(() => {
  notificationStore.getMessage(+route.params.id);
});

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          class: "font-semibold text-sm",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack()))
        }, "Volver"),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("h1", _hoisted_9, _toDisplayString(_unref(message)?.subject), 1)
          ]),
          (_unref(message)?.createdAt)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Enviado el " + _toDisplayString(new Date(_unref(message)?.createdAt).toLocaleDateString("es-CL", {
                style: "short",
              })), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            (_unref(message)?.sendingShareholder)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, " (" + _toDisplayString(_unref(message)?.sendingShareholder.length) + " usuarios ) ", 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(message)?.sendingShareholder, (shareholder) => {
              return (_openBlock(), _createElementBlock("div", {
                key: shareholder.id
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", _hoisted_17, _toDisplayString(shareholder.shareholder?.accountOwnerName), 1),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(shareholder.shareholder?.email), 1)
                ])
              ]))
            }), 128))
          ])
        ]),
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(message)?.description), 1)
        ]),
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          (_unref(message)?.files && _unref(message)?.files.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(message)?.files, (file, indexFile) => {
                  return (_openBlock(), _createElementBlock("div", { key: indexFile }, [
                    _createElementVNode("a", {
                      class: "flex flex-row items-center gap-2 px-3 py-1.5 text-sm rounded-full bg-gray-100 text-gray-800",
                      onClick: 
                  () =>
                    _unref(notificationStore).downloadFile(
                      file.id,
                      _unref(extractFilename)(file.thumbnail)
                    )
                
                    }, [
                      _createVNode(_component_mdicon, { name: "download" }),
                      _createTextVNode(" " + _toDisplayString(_unref(extractFilename)(file.thumbnail)), 1)
                    ], 8, _hoisted_27)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_mdicon, { name: "information" }),
                  _hoisted_30
                ])
              ]))
        ])
      ])
    ])
  ]))
}
}

})